// extracted by mini-css-extract-plugin
export default {"logo":"ShopLogo_logo__yxSR7"};